import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Button, useTheme } from 'react-native-paper';
import { LucideIcon } from 'lucide-react-native';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  size = 'medium',
}: EmptyStateProps) {
  const theme = useTheme();

  const getIconSize = () => {
    switch (size) {
      case 'small':
        return 48;
      case 'large':
        return 96;
      default:
        return 72;
    }
  };

  const getSpacing = () => {
    switch (size) {
      case 'small':
        return 16;
      case 'large':
        return 32;
      default:
        return 24;
    }
  };

  return (
    <View style={[styles.container, { padding: getSpacing() }]}>
      <Icon
        size={getIconSize()}
        color={theme.colors.outline}
        style={styles.icon}
      />
      
      <Text
        variant={size === 'large' ? 'headlineSmall' : 'titleLarge'}
        style={[styles.title, { color: theme.colors.onSurface }]}
      >
        {title}
      </Text>
      
      <Text
        variant={size === 'small' ? 'bodyMedium' : 'bodyLarge'}
        style={[styles.description, { color: theme.colors.onSurfaceVariant }]}
        textAlign="center"
      >
        {description}
      </Text>
      
      {action && <View style={styles.actionContainer}>{action}</View>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
  },
  icon: {
    marginBottom: 16,
    opacity: 0.6,
  },
  title: {
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 8,
  },
  description: {
    textAlign: 'center',
    lineHeight: 22,
    marginBottom: 24,
  },
  actionContainer: {
    alignItems: 'center',
  },
});
